import React from "react";
import styles from "../../containers/Review/Review.module.scss";

const EstimatedStartDateModal = ({ withIn3Days }) => {
  return (
    <div>
      {withIn3Days ? (
        <div className={styles["estimateModal"]}>
          Withdrawals will take place on the selected business date(s). If
          one of your selected dates falls on a weekend or holiday, your RMD
          will be withdrawn on the next business day.
        </div>
      ) : (
        <div className={styles["estimateModal"]}>
          Withdrawals will take place on the selected business date(s). If
          one of your selected dates falls on a weekend or holiday, your RMD
          will be withdrawn on the next business day.
          <br />
          <br />
          <span className="emphasis">
            Your Auto-RMD is scheduled within three business days of today’s
            date.
          </span>{" "}
          This may cause your first withdrawal to take place at the next
          instance of your chosen date.
        </div>
      )}
    </div>
  );
};

export default EstimatedStartDateModal;
